export default "__VITE_ASSET__BOjshGGU__"